<script setup lang="ts">
defineProps<{ label: string; value?: string }>();
</script>

<template>
  <section class="bg-creux rounded-[24px]">
    <header class="flex items-center justify-between gap-3 px-[13px] py-[9px]">
      <h3
        class="text-encre-douce text-[12px] leading-[1.2] font-semibold tracking-[0.9px] uppercase"
      >
        {{ label }}
      </h3>
      <p v-if="value" class="text-[14px] leading-[1.4] font-semibold">
        {{ value }}
      </p>
    </header>
    <div class="bg-carte rounded-[24px] px-[13px] py-[7px]">
      <slot />
    </div>
  </section>
</template>
